// HIGFIX4A (design/style-guide.md section 8): the one disabled-reason pattern. A disabled button names why, in one short
// line right under it, and the button points at that line with aria-describedby. An empty reason removes the line.

/** Shows `reason` under `button` (or removes it when `reason` is empty). The line is created once and reused. */
export function setDisabledReason(button: HTMLElement, reason: string): HTMLElement | undefined {
  const id = `${button.id !== "" ? button.id : (button.dataset["testid"] ?? "button")}-reason`;
  let line = button.parentElement?.querySelector<HTMLElement>(`:scope > [data-reason-for="${CSS.escape(id)}"]`) ?? null;
  if (reason === "") {
    line?.remove();
    removeDescribedBy(button, id);
    return undefined;
  }
  if (line === null) {
    line = document.createElement("p");
    line.className = "disabled-reason";
    line.id = id;
    line.dataset["testid"] = id;
    line.dataset["reasonFor"] = id;
    button.after(line);
  }
  line.textContent = reason;
  const described = (button.getAttribute("aria-describedby") ?? "").split(" ").filter((part) => part !== "");
  if (!described.includes(id)) button.setAttribute("aria-describedby", [...described, id].join(" "));
  return line;
}

function removeDescribedBy(button: HTMLElement, id: string): void {
  const rest = (button.getAttribute("aria-describedby") ?? "").split(" ").filter((part) => part !== "" && part !== id);
  if (rest.length === 0) button.removeAttribute("aria-describedby");
  else button.setAttribute("aria-describedby", rest.join(" "));
}
